import ListStaffContainer from './list_staff_container';

const ListStaff = ListStaffContainer;
export default ListStaff;
